// The referral program: the "invited you" bar, and the line on sign-up, the
// paywall and /pricing, for visitors who arrived on a creator's ?ref= link
// (apps/web/components/referral/InvitedBar, InvitedLine). See
// messages/README.md.
// "Voice Pass" follows nav.profile.voicePass in each language.
export const referral = {
  en: {
    "referral.bar.title": "{name} invited you",
    "referral.bar.detail": "Subscribe and get a free Voice Pass.",
    "referral.bar.cta": "Free Voice Pass",
    "referral.bar.hide": "Hide",
    "referral.line.title": "{name} invited you",
    "referral.line.detail": "Your free Voice Pass comes with your plan.",
    // Copy-link toasts (lib/referral/shareToast) and the strip under covers and
    // voices (components/referral/EarnNudge).
    "referral.share.copied": "Link copied with your code",
    "referral.share.copiedDetail":
      "You earn 20% of what people pay when they join from it.",
    "referral.share.copiedPlain": "Link copied",
    "referral.share.earn": "Earn 20% when friends subscribe",
    "referral.nudge.coverNoCode":
      "Get 20% when people join Jammable from your covers.",
    "referral.nudge.coverWithCode":
      "Your share link carries your code: 20% when people subscribe.",
    "referral.nudge.voiceNoCode":
      "Share your voice and get 20% when people join from it.",
    "referral.nudge.voiceWithCode":
      "Share your voice: your link carries your code, 20% when people subscribe.",
    "referral.nudge.earnings": "Earnings",
    "referral.nudge.getCode": "Get your code",
  },
};
